import React from 'react'
import { routes } from '../../Utils'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { getSignUpState, setIsNewUserAutoLoggedIn, setMobileNumberVerified } from '../../Store'
import { Content, SignUpPageStyled } from '../SignUpPage.styled'
import { incrementQuickCounter } from '@mobi/utils/logging/quickCounter'
import { useBetAccount } from '@mobi/account/Hooks'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { LoadingSpinner } from '@mobi/component-library/Feedback/LoadingSpinner'
import { signupTracker } from '@mobi/account/Common/Analytics'

export type MfaVerificationPage = ({
  accountNumber,
  onCompleted,
}: {
  accountNumber: number
  onCompleted: (skipped: boolean) => void
}) => React.JSX.Element

interface PhoneNumberValidationProps {
  MfaVerificationPage: React.MemoExoticComponent<MfaVerificationPage>
}

export const PhoneNumber = ({ MfaVerificationPage }: PhoneNumberValidationProps) => {
  const nextStep = routes.security
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const state = useSelector(getSignUpState)

  const { data, isPending, isError } = useBetAccount()

  const onCompleted = (skipped: boolean) => {
    signupTracker({
      interaction_type: 'Mobile Number Verification Success',
      signUpFlow: state.isVerificationAccount ? 'ID Verification' : 'Standard',
      mobileNumberVerifySkipped: skipped,
    })
    if (!skipped) {
      dispatch(setMobileNumberVerified())
    }
    incrementQuickCounter(`mfa-in-signup-phone-verifiy-${skipped ? 'skipped' : 'complete'}`)
    navigate(nextStep)
  }

  if (isPending)
    return (
      <Flex justifyContent='center' alignItems='center'>
        <LoadingSpinner />
      </Flex>
    )

  if (isError || !data) {
    dispatch(setIsNewUserAutoLoggedIn(false))
    navigate(routes.signUpUnsuccessful)
    return
  }

  return (
    <SignUpPageStyled>
      <Content>
        <MfaVerificationPage accountNumber={data.BetAccountNumber} onCompleted={onCompleted} />
      </Content>
    </SignUpPageStyled>
  )
}
